var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_vm._t("default"),_vm._v(" "),(!_vm.noDivider)?_c('hr',{directives:[{name:"bem",rawName:"v-bem:divider",arg:"divider"}]}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }